import React from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { EditarIcon } from '../../../assets/svg/iconos';
import { obtenerEstadoCitaParaUI } from '../../../helpers/citas';


export const UltimaReserva = ({ cita, createCita, editCita, setActiveCita, citasHistoria, isNewCliente = false, factorRiesgo }) => {
    const { colores } = useSelector(state => state.ui);
    const { variantes } = useSelector(state => state.variantes);

    const getVariante = (v) => {
        const id = v && (v._id || v);
        if (!id) return null;
        return variantes.find(x => String(x._id || x) === String(id));
    }

    const editarCita = (cita)=>{
        setActiveCita(cita);
        editCita(cita);
    }

    const citasToShow = isNewCliente ? [] : (citasHistoria && Array.isArray(citasHistoria) ? citasHistoria : []);

    return (
        <div className='ultima-reserva'>
            {citasToShow && citasToShow.length > 0 && (
                citasToShow.map(cita => {
                    const variantesInCita = cita?.variantes?.map(v => getVariante(v)?.nombre).filter(Boolean).join(', ') || '';
                    const estadoCita = obtenerEstadoCitaParaUI(cita);
                    return (
                    <div className='cita-row' key={cita.id || cita._id}  style={{ backgroundColor: colores.color6 }}>
                    <div className='cita-date'>
                        <p><b>{moment(cita?.fecha).format('D/M/YYYY')}</b> {moment(cita?.fecha).format('H:mm')}h</p>
                    </div>
                    <div className='cita-servicio'>
                            <p>{cita?.servicios?.map(s => `${s.nombre || s}${variantesInCita ? ` (${variantesInCita})` : ''}`).join(', ')}</p>
                    </div>
                    <div className='cita-profesional'>
                        <p>{cita?.profesional?.nombre || 'N/A'}</p>
                    </div>
                    <div className='cita-sucursal'>
                        <p>{cita?.sucursal?.nombre || 'N/A'}</p>
                    </div>
                    <div className={`cita-activa${estadoCita.enProcesoPago ? ' cita-activa--proceso-pago' : ''}`}>
                        <p>{estadoCita.label}</p>
                    </div>
                    <div
                        className={`cita-indicador factor-riesgo-${factorRiesgo != null ? (factorRiesgo >= 50 ? 'rojo' : factorRiesgo >= 25 ? 'amarillo' : 'verde') : 'default'}`}></div>
                    { moment(cita?.fecha).isAfter(moment()) && (cita.estado == "Activa" || cita.estado === "") &&
                        <button
                                onClick={()=>editarCita(cita)}
                                style={{ backgroundColor: colores.color6 }}
                        >
                                <EditarIcon color={ colores.colorPrincipal } width="12" height='12'/>
                        </button> 
                        }
                    </div>
                );
                })
            )}
        </div>
    )
}
